import * as api from './api'
import { ONE_HOUR } from '@/constants/time'
import { checkTtlDate } from '@/helper'

export default {
  async loadData ({ commit, state }, { force = false } = {}) {
    const isNeedUpdate = checkTtlDate({
      timeUpdate: state.lastDateUpdated,
      ttlTime: ONE_HOUR,
    })

    if (!force && state.data.length && !isNeedUpdate) {
      return { data: state.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)
      commit('setLastDateUpdated')

      return { data: data.data }
    }

    return { error: data.data }
  }
}